import React from 'react';

const Lock = (props) => {
  const { reason, className = '' } = props;
  return (
    <span className={`help-tooltip-wrapper ${className}`}>
      <i className="fe-lock" style={{ color: '#72747b' }} />
      <span className="help-tooltip" style={{ color: '#72747b' }}>
        {reason}
      </span>
    </span>
  );
};

export default Lock;
